import {Box, Button} from '@mui/material'
import {useState} from 'react'
import {useTranslation} from 'react-i18next'

export default function UploadVideo({base64Image, setBase64Image, maxSize}: any) {
  const {t} = useTranslation()

  const handleImageChange = (event: any) => {
    const file = event.target.files[0]
    if (file) {
      if (maxSize && file.size > maxSize) {
        alert(
          t('videoTooLarge') || `The video file is too large. Maximum size is ${maxSize / 1000}MB.`
        )
        return
      }
      setBase64Image(file)
    }
  }

  return (
    <Box>
      <Button
        sx={{
          color: 'var(--main-color)',
          padding: '13px 21px',
          background: 'rgba(216, 25, 35, 0.1)',
          borderRadius: '7px',
          marginTop: '10px',
        }}
        component='label'
      >
        {t('uploadVideo')}
        <input hidden accept='video/*' onChange={handleImageChange} multiple={false} type='file' />
      </Button>
    </Box>
  )
}
